import { SupportTicketStatusEnum } from '@/services/api-clients';
import i18n from '@/i18n/config';
import { LF } from '@/i18n/LF';

export function supportTicketStatusNameFilter(status: SupportTicketStatusEnum): string {
  switch (status) {
    case SupportTicketStatusEnum.Open: return i18n.t(LF.SupportStatusOpen) as string;
    case SupportTicketStatusEnum.InProgress: return i18n.t(LF.SupportStatusInProgress) as string;
    case SupportTicketStatusEnum.Closed: return i18n.t(LF.SupportStatusClosed) as string;
    default: return '';
  }
}
